let url = "https://xaytzdh.cn";
export default {
  GetBanner: `${url}/Frontstage/Home/GetBanner`, // 获取轮播图
  GetFoot: `${url}/Frontstage/Home/GetFoot`, // 底部信息
  GetCompany: `${url}/Company/Web_Company/GetCompany`, // 公司信息
  GetRol: `${url}/Frontstage/Home/GetRol`, // 获取菜单
  GetType: `${url}/Frontstage/GetType/GetType`, // 获取分类
  GetNewList: `${url}/Frontstage/Home/GetNewList`, // 新闻首页内容
  GetNewsList: `${url}/Frontstage/Web_New/GetDataList`, // 新闻列表页
  GetNewTheDataSelect: `${url}/Frontstage/Web_New/GetTheData`, // 新闻列表页指定查询
  GetSolutionDetail: `${url}/Frontstage/Home/GetSolutionDetail`, // 获取首页解决方案
  GetSoluteList: `${url}/Frontstage/Web_SolutionDetail/GetDataList`, // 解决方案列表
  GetSpecifiedList: `${url}/Backstage/Web_SolutionDetail/GetTheData`, // 解决方案指定查询
  GetPerformanceAll: `${url}/Frontstage/Web_Performance/All`, // 查询企业业绩所有分类
  GetPerTwoCoor: `${url}/Frontstage/Web_Performance/GetTwoAll`, // 所有行业案例二级坐标
  GetThis: `${url}/Frontstage/Web_Performance/GetThis`, // 指定企业业绩查询
  GetIntroList: `${url}/Frontstage/Web_AboutUS/GetDataList`, // 关于优特-企业简介
  GetWeb_CaseList: `${url}/Frontstage/Home/GetWeb_CaseList`, // 首页工程案例
  GetCaseList: `${url}/Frontstage/Web_Case/GetDataList`, // 工程案例列表页
  GetTheData: `${url}/Frontstage/Web_Case/GetTheData`, // 工程案例列指定查找
  GetCaseData: `${url}/Frontstage/Web_Case/GetTheData`, // 工程案例详情页
  GetDataList: `${url}/Frontstage/Home/GetGaseDetailList`, // 获取首页产品中心
  GetProductList: `${url}/Frontstage/Web_GaseDetail/GetDataList`, // 产品列表
  GetTheProductData: `${url}/Frontstage/Web_GaseDetail/GetTheData`, // 指定产品详情
  SaveData: `${url}/Frontstage/Web_LeaveMessage/SaveData`, // 添加或编辑留言
  GetNextData: `${url}/Frontstage/Web_New/GetData`, // 获取上下页及新闻详情页
  GetVideoList: `${url}/Frontstage/Web_Video/GetDataList`, // 视频
  GetPerFirst: `${url}/Frontstage/Web_Performance/AllOneBackstage`, // 企业业绩一级分类
  GetLinks: `${url}/Frontstage/Home/GetShipLink`, // 获取友情链接
  GetConf: `${url}/Backstage/Base_Basic/GetTheData`, // 配置信息
  GetLabelList:`${url}/Backstage/Web_Label/GetDataList`, // 标签列表


   /********************* 一级ID配置 ****************/
   ID1:'039FBC38CC5F3-C58937D3-ED38-4536-BCAD-32981D1147D0', // 新闻资讯
   ID2: '039FBCEB5B5DF-55A0459E-500D-480D-B985-85F7C3AE280B', // 工程案例
   ID3:'12', // 产品中心
   ID4:'17', // 联系我们
   ID5:'039FBD44CD807-78AEBF0F-C70E-4C11-B818-72E06ED38632', // 解决方案
   ID6:'2', // 关于优特
};
